import React, {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import stylesElencoUtenti from "../ElencoUtenti.module.css";
import common from "../../../translations/it/common.json";
import Input from "../../../components/inputText/Input";
import Select from "../../../components/Select/Select";
import Button from "../../../components/Button/Button";
import Utils from "../../../utils/Utils";

function FormUtente(props) {
    const [form, setForm] = useState(null)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    useEffect(() => {
        createForm(props.gruppiPerApplicazione ?? [])
    }, [props])

    function createForm(gruppiApplicazione) {
        let cf = props.state && props.state.codiceFiscale ? props.state.codiceFiscale.replace("TINIT-","") : ""
        let newForm = (
            <div>
                <div style={{float: "right"}}>
                    <p style={{fontWeight: "bold", fontSize: "16px", color: "red"}}>Campo obbligatorio*</p>
                </div>
                <br/>
                <Row>
                    <div className="col-6">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.nome}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Input id={props.modifica ? "nomeModifica" : "nome"}
                               placeholder={"Nome"}
                               onChange={(event) => props.onChange(event.target.id, event.target.value)}
                               value={props.state && props.state.nome ? props.state.nome : ""}/>
                    </div>
                    <div className="col-6">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.cognome}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Input id={props.modifica ? "cognomeModifica" : "cognome"}
                               placeholder={"Cognome"}
                               onChange={(event) => props.onChange(event.target.id, event.target.value)}
                               value={props.state && props.state.cognome ? props.state.cognome : ""}
                        />
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-6">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.telefono}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Input id={props.modifica ? "telefonoModifica" : "telefono"}
                               placeholder={"telefono"}
                               onChange={(event) => props.onChange(event.target.id, event.target.value)}
                               value={props.state && props.state.telefono ? props.state.telefono : ""}
                        />
                    </div>
                    <div className="col-6">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.email}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Input id={props.modifica ? "mailModifica" : "mail"}
                               placeholder={"Email"}
                               onChange={(event) => props.onChange(event.target.id, event.target.value)}
                               value={props.state && props.state.mail ? props.state.mail : ""}
                        />
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-12">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.codice}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Input id={props.modifica ? "codiceFiscaleModifica" : "codiceFiscale"}
                               placeholder={"Codice Fiscale"}
                               errorClause={props.state.codiceFiscale && !Utils.isCFValid(cf)}
                               errorMessage={"Codice fiscale non valido"}
                               disabled={props.modifica}
                               onChange={(event) => props.onChange(event.target.id, event.target.value)}
                               value={cf}
                        />
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-12">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.ruolo}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Select id={props.modifica ? "ruoloModifica" : "ruolo"}
                                options={gruppiApplicazione}
                                onChange={(event) => props.onChange(event.target.id, event.target.value)}
                                value={props.state && props.state.ruolo ? props.state.ruolo : ""}
                        />
                    </div>
                </Row>
                <Row style={{marginTop: "5px"}}>
                    <div className="col-12">
                        <span className={stylesElencoUtenti.stileFont}>{common.Modale.ente}</span>
                        <span className={stylesElencoUtenti.stileFontObbligatorieta}>*</span>
                        <Select id={props.modifica ? "enteModifica" : "ente"}
                                            functionMap={props.suggestionsSportelli.map((oggetto) => {
                                                return (
                                                    <option
                                                        key={oggetto.codice}
                                                        value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                            multiple={true}
                                            autocomplete={true}
                                            onChange={(event) => props.onChange(event.target.id, event)}
                                            value={props.state && props.state.ente ? props.state.ente : ""}
                        />
                    </div>
                </Row>
                {props.modifica ? <div className={"row"} style={{marginTop: "2rem", marginBottom: "2rem"}}>
                    <div className="col-4">
                        <Button
                            id={"annulla"}
                            onClick={props.onClickAnnulla}
                            typeButton={"White"}
                            disabled={false}
                            text={"Annulla"}
                            style={{height: "45px", width: "180px"}}
                            dataDismiss="modal"
                        />
                    </div>
                    <div className="col-4" >
                        <Button
                            id={"elimina"}
                            onClick={props.onClickElimina}
                            typeButton={"White"}
                            disabled={sessioneUtente?.ruolo?.toUpperCase() === "RAF-RULSS" && (props.state.ruolo.toUpperCase() === "RAF-ADMIN" || props.state.ruolo.toUpperCase() === "RAF-RDSS")}
                            text={"Elimina"}
                            style={{height: "45px", width: "180px", color: "red"}}
                            dataDismiss="modal"
                        />
                    </div>
                    <div className="col-4">
                        <Button
                            id={props.modifica ? "modifica" : "salva"}
                            onClick={props.onClickSalvaModifica}
                            typeButton={"Blue"}
                            disabled={props.disabledButtonSalvaModifica || (sessioneUtente?.ruolo?.toUpperCase() === "RAF-RULSS" && (props.state.ruolo.toUpperCase() === "RAF-ADMIN" || props.state.ruolo.toUpperCase() === "RAF-RDSS"))}
                            text={"Salva"}
                            style={{height: "45px", width: "180px"}}
                            dataDismiss="modal"
                        />
                    </div>

                </div> : <div className={"row"} style={{marginTop: "2rem", marginBottom: "2rem"}}>
                    <div className="col-6">
                        <Button
                            id={"annulla"}
                            onClick={props.onClickAnnulla}
                            typeButton={"White"}
                            disabled={false}
                            text={"Annulla"}
                            style={{height: "45px", width: "180px", float: "left"}}
                            dataDismiss="modal"
                        />
                    </div>
                    <div className="col-6">
                        <Button
                            id={props.modifica ? "modifica" : "salva"}
                            onClick={props.onClickSalvaModifica}
                            typeButton={"Blue"}
                            disabled={props.disabledButtonSalvaModifica}
                            text={"Salva"}
                            style={{height: "45px", width: "180px", float: "right"}}
                            dataDismiss="modal"
                        />
                    </div>

                </div>}
            </div>
        )
        setForm(newForm)
    }

    return (form)

}

export default FormUtente